import React, { Component, Fragment } from 'react';
import { Table, Jumbotron, Row, Col, Button, Form  } from 'react-bootstrap';
import Menu from '../menu';
import config from '../../config';

export class ReporteNomina extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!mm
        const yyyy = today.getFullYear();
        const todayFormat = yyyy + "-" + mm + "-" + dd;
        this.state = {
            info: [],
            fecha_inicial: todayFormat,
            fecha_final: todayFormat,
            empresa:currentCompany
        }
    }

    updateReport = () => {
        const { fecha_inicial, fecha_final, empresa } = this.state;
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                fecha_inicial,
                fecha_final,
                empresa
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }

        fetch(config.servBackEnd + '/reports/companypayroll', datasend)
            .then(res => res.json())
            .then((data) => {
                if (data.ok) {
                    const info = data.data;
                    this.setState({ info })
                } else {
                    this.setState({ info: [] })
                }
            })
            .catch((error) => console.error(error))
    }

    render() {
        const { info } = this.state;
        return (
            <Fragment>
                <Menu></Menu>
                <Jumbotron className="Jumbotron">REPORTE ESTADO NOMINA POR EMPRESAS</Jumbotron>
                <Row>
                    <Col>
                        Fecha Inicial <Form.Control type="date" onChange={(e) => this.setState({ fecha_inicial: e.target.value })} value={this.state.fecha_inicial} />
                    </Col>
                    <Col>
                        Fecha Final <Form.Control type="date" onChange={(e) => this.setState({ fecha_final: e.target.value })} value={this.state.fecha_final} />
                    </Col>
                    <Col>
                        <Button variant="primary" className="m-3" onClick={this.updateReport} >Genera Informe</Button>
                    </Col>
                </Row>
                <Table  className="tableFixHead">
                    <thead>
                        <tr>
                            <th>NIT</th>
                            <th>NOMBRE EMPRESA</th>
                            <th>FECHA</th>
                            <th>SIN CARGAR</th>
                            <th>SIN CONFIRMAR</th>
                            <th>EXITOSOS SIN ENVIAR</th>
                            <th>CON ERROR</th>
                            <th>ENVIADOS</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            info.map((element, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{element.ID_EMPRESA}</td>
                                        <td>{element.NOMBRE_EMPRESA}</td>
                                        <td>{element.FECHA_DOCUMENTO}</td>
                                        <td>{element.SIN_CARGAR}</td>
                                        <td>{element.SIN_CONFIRMAR}</td>
                                        <td>{element.SIN_ENVIAR}</td>
                                        <td>{element.CON_ERROR}</td>
                                        <td>{element.ENVIADOS}</td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </Table>
            </Fragment>
        )
    }
}

export default ReporteNomina
